import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Check, RefreshCw } from 'lucide-react';
import { fetchAppLinks } from '../../hooks/useAppLinks';

const API = process.env.REACT_APP_BACKEND_URL;
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('admin_token')}` });

export const AppBannerTab = () => {
  const [cfg, setCfg] = useState(null);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => { fetchAppLinks(true).then(setCfg); }, []);

  const set = (k, v) => { setSaved(false); setCfg(p => ({ ...p, [k]: v })); };

  const save = async () => {
    setSaving(true); setError('');
    try {
      const { data } = await axios.put(`${API}/api/marketing/app-links`, cfg, { headers: headers() });
      setCfg(data); setSaved(true); fetchAppLinks(true);
    } catch (e) { setError(e.response?.data?.detail || 'No se pudo guardar'); }
    finally { setSaving(false); }
  };

  if (!cfg) return <p className="text-gray-400">Cargando...</p>;

  return (
    <Card className="bg-gray-800 border-gray-700 p-6 max-w-2xl" data-testid="app-banner-tab">
      <h3 className="text-lg font-semibold text-white mb-1">Banner de descarga y enlaces</h3>
      <p className="text-xs text-gray-500 mb-6">El banner aparece arriba del sitio solo en celulares Android. Los enlaces se usan tambien en el footer.</p>
      <div className="flex items-center justify-between py-3 border-b border-gray-700/50 mb-4">
        <div>
          <p className="text-sm font-medium text-gray-200">Mostrar banner de descarga</p>
          <p className="text-xs text-gray-500">Barra superior con boton "Descargar"</p>
        </div>
        <button onClick={() => set('is_app_banner_active', !cfg.is_app_banner_active)} data-testid="app-banner-toggle"
          className={`relative w-11 h-6 rounded-full transition-colors ${cfg.is_app_banner_active ? 'bg-orange-500' : 'bg-gray-600'}`}>
          <span className={`absolute top-0.5 left-0.5 w-5 h-5 rounded-full bg-white transition-transform ${cfg.is_app_banner_active ? 'translate-x-5' : ''}`} />
        </button>
      </div>
      <div className="space-y-4">
        {[
          ['banner_text', 'Texto del banner', 'app-banner-text-input'],
          ['android_url', 'Enlace Google Play (Android)', 'app-android-url-input'],
          ['ios_url', 'Enlace App Store (iOS) — vacio = oculto', 'app-ios-url-input'],
        ].map(([k, label, tid]) => (
          <div key={k}>
            <label className="text-sm text-gray-400 block mb-1.5">{label}</label>
            <Input value={cfg[k] || ''} onChange={e => set(k, e.target.value)} className="bg-gray-700 border-gray-600 text-white" data-testid={tid} />
          </div>
        ))}
      </div>
      <Button onClick={save} disabled={saving} className="mt-6 bg-orange-500 hover:bg-orange-600 text-white" data-testid="app-banner-save-btn">
        {saving ? <RefreshCw className="w-4 h-4 animate-spin mr-2" /> : <Check className="w-4 h-4 mr-2" />}
        {saving ? 'Guardando...' : saved ? 'Guardado' : 'Guardar banner y enlaces'}
      </Button>
      {error && <p className="text-sm text-red-400 mt-3" data-testid="app-banner-error">{error}</p>}
    </Card>
  );
};
